import Soesvinget from './Soesvinget';

export default Soesvinget;